import { AxiosResponse } from 'axios';
import { BlobDocumentReponse } from '../../../Model/Dto/BlobDocument';
import {
    FeedbackDataSearchResponse,
    FeedbackExternalDto,
    BEEGeneratedCertificate,
    FeedbackEmailDtoIn,
    FeedbackSearchRequest,
    VAClientDataSearchResponse,
    VAClientSearchRequest,
    VerificationAgencyClient,
    VAClientData
} from '../../../Model/Dto/VerificationAgency/VerificationAgencyClient';
import { VerificationAgencyClientApplication } from '../../../Model/Dto/VerificationAgency/VerificationAgencyClientApplication';
import { axiosCoreInstance } from '../../AxiosCoreInterceptor';

import * as ApiUrls from './ApiUrl.VerificationAgencyClient';
import { Guid } from "guid-typescript";

export const VerificationAgencyClientService = {
    GetById: (id: number): Promise<AxiosResponse<VerificationAgencyClient.VerificationAgencyClientResponse>> =>
        axiosCoreInstance.get(ApiUrls.CompanyDetails + id),
    CreateEntry: (data: VerificationAgencyClient.CompanyDetailsCreateDtoIn): Promise<AxiosResponse<VerificationAgencyClient.VerificationAgencyClientResponse>> =>
        axiosCoreInstance.post(ApiUrls.CompanyDetails, data),
    UpdateEntry: (data: VerificationAgencyClient.CompanyDetailsUpdateDtoIn): Promise<AxiosResponse<VerificationAgencyClient.VerificationAgencyClientResponse>> =>
        axiosCoreInstance.put(ApiUrls.CompanyDetails, data),
    VAClientSearch: (data: VAClientSearchRequest): Promise<AxiosResponse<VAClientDataSearchResponse>> =>
        axiosCoreInstance.post(ApiUrls.VAClientSearch, data),
    GetReferredBy: (id: number): Promise<AxiosResponse<VerificationAgencyClient.ReferredByDto>> =>
        axiosCoreInstance.get(ApiUrls.ReferredBy + id),
    UpdateReferredBy: (data: VerificationAgencyClient.ReferredByDto): Promise<AxiosResponse<VerificationAgencyClient.ReferredByDto>> =>
        axiosCoreInstance.post(ApiUrls.ReferredBy, data),
    GetAll: (): Promise<AxiosResponse<VerificationAgencyClient.VerificationAgencyClientResponse[]>> => axiosCoreInstance.get(ApiUrls.GetAll),
    GetClientNames: (searchValue: string): Promise<AxiosResponse<VAClientData[]>> =>
        axiosCoreInstance.get(ApiUrls.GetClientNames + '?searchValue=' + searchValue),
    DeleteVAClient: (id: number): Promise<AxiosResponse<void>> =>
        axiosCoreInstance.delete(`${ApiUrls.VerificationAgencyClient}${id}`),
    GetCompanyDetailsForExternalApplication: (token: string): Promise<AxiosResponse<VerificationAgencyClient.VerificationAgencyClientResponse>> =>
        axiosCoreInstance.get(ApiUrls.GetCompanyDetailsForExternalApplication + token),
    GetCompanyDetailsForExternalFeedback: (token: string): Promise<AxiosResponse<VerificationAgencyClient.VerificationAgencyClientResponse>> =>
        axiosCoreInstance.get(ApiUrls.GetCompanyDetailsForExternalFeedback + token),
    UpdateEntryExternalPage: (data: VerificationAgencyClient.CompanyDetailsTempAccessUpdateDtoIn): Promise<AxiosResponse<VerificationAgencyClient.VerificationAgencyClientResponse>> =>
        axiosCoreInstance.put(ApiUrls.UpdateCompanyDetailsByAccessToken, data),
    GetReferredByExternalPage: (id: number, token: string): Promise<AxiosResponse<VerificationAgencyClient.ReferredByDto>> =>
        axiosCoreInstance.get(ApiUrls.ReferredBy + id + '/' + token),
    UpdateReferredByExternalPage: (data: VerificationAgencyClient.ReferredByTempAccessDto): Promise<AxiosResponse<VerificationAgencyClient.ReferredByDto>> =>
        axiosCoreInstance.post(ApiUrls.ReferredByExternalPage, data),
    DeleteGeneratedCertificate: (id: string): Promise<AxiosResponse<void>> =>
        axiosCoreInstance.delete(`${ApiUrls.BEEGeneratedCertificates}${id}`),
    SearchGeneratedCertificates: (searchInput: BEEGeneratedCertificate.SearchRequest): Promise<AxiosResponse<BEEGeneratedCertificate.SearchResponse>> =>
        axiosCoreInstance.post(ApiUrls.SearchGeneratedCertificates, searchInput),
    DownloadCertificate: (certificateId: string): Promise<AxiosResponse<BlobDocumentReponse>> =>
        axiosCoreInstance.get(`${ApiUrls.DownloadCertificate}${certificateId}`),
    CreateFeedbackEntry: (data: VerificationAgencyClient.FeedbackDetailDto): Promise<AxiosResponse<VerificationAgencyClient.FeedbackResponseDto>> =>
        axiosCoreInstance.post(ApiUrls.FeedbackDetails, data),
    FeedbackSearch: (data: FeedbackSearchRequest): Promise<AxiosResponse<FeedbackDataSearchResponse>> =>
        axiosCoreInstance.post(ApiUrls.FeedbackSearch, data),
    DeleteFeedbackEntry: (id: number): Promise<AxiosResponse<void>> =>
        axiosCoreInstance.delete(`${ApiUrls.FeedbackDetails}${id}`),
    SendFeedbackLink: (data: FeedbackEmailDtoIn): Promise<AxiosResponse<any>> =>
        axiosCoreInstance.post(ApiUrls.FeedbackSendEmail, data),
    IsTokenActive: (token: Guid): Promise<AxiosResponse<FeedbackExternalDto>> =>
        axiosCoreInstance.get(ApiUrls.IsTokenActive + token),
    GetFeedbackById: (id: number): Promise<AxiosResponse<VerificationAgencyClient.FeedbackDetailDto>> =>
        axiosCoreInstance.get(ApiUrls.FeedbackDetails + id),
};
